import PropTypes from 'prop-types'
import React from 'react'

function ChevronLeftIconSmall({ className }) {
  return (
    <span className={`chevron-left-icon ${className || ''}`}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 6.3439523 6.3500001"
        version="1.1"
      >
        <g transform="translate(-271.86901,-340.92364)">
          <path
            d="m 276.32944,347.00906 0.3942,-0.3942 -2.56188,-2.51637 2.56175,-2.51621 -0.39405,-0.39405 -2.97112,2.91042 z"
          />
        </g>
      </svg>
    </span>
  )
}

ChevronLeftIconSmall.propTypes = {
  className: PropTypes.string
}

export default ChevronLeftIconSmall
